import { render, staticRenderFns } from "./ProductCategoryTranslationEditPopup.vue?vue&type=template&id=cc7dc1b2&"
import script from "./ProductCategoryTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports